module.exports = __webpack_public_path__ + "static/assets/23b3e4b4a29772d77f2cb6f58bcdf799.gif";